'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=require('./createColorPalette'),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var brick={1:'#fef3f1',2:'#fac3bb',3:'#faa094',4:'#fa7d6d',5:'#eb4f3b',6:'#d24634',7:'#b83e2e',8:'#9e3528',9:'#7a291f',10:'#571d16',inflection:6};exports.default=(0,_createColorPalette2.default)(brick,'brick');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vitalsource/vstui/colors/brick.js
// module id = 530
// module chunks = 162